export default "__VITE_ASSET__BerPushc__"